import {
  PhoneIphoneOutlined,
  AppSettingsAltOutlined,
  MarkEmailReadOutlined,
} from "@mui/icons-material";
import { Products } from "../../enum/campaign";
import { CampaignType } from "../../enum/campaign";
import { BidTypes } from "../../enum/campaign";

export const minTotalBudget = 100;

export const fileTypes = ["JPG", "PNG", "JPEG", "MP4", "WAV"];

export const bidTypes = [
  {
    label: "CPC",
    app: [Products.App, Products.Website],
    value: BidTypes.CPC,
  },
  {
    label: "CPI",
    app: [Products.App],
    value: BidTypes.CPI,
  },
  {
    label: "CPL",
    app: [Products.Website],
    value: BidTypes.CPL,
  },
];

export const product = [
  {
    label: "App",
    value: Products.App,
  },
  {
    label: "Website",
    value: Products.Website,
  },
];

export const campaignType = [
  {
    label: "Direct Apps",
    Icon: AppSettingsAltOutlined,
    value: CampaignType.DirectApps,
  },
  {
    label: "Open",
    Icon: MarkEmailReadOutlined,
    value: CampaignType.Open,
  },
  {
    label: "OEM",
    Icon: PhoneIphoneOutlined,
    value: CampaignType.OEM,
  },
];

export const trackingApps = [
  {
    label: "App Flyer",
    icon: "app-fyer.png",
    value: "app-fyer",
  },
  {
    label: "Adjust",
    icon: "adjust.png",
    value: "adjust",
  },
  {
    label: "Branch",
    icon: "branch.png",
    value: "branch",
  },
  {
    label: "Kochava",
    icon: "kochava.png",
    value: "kochava",
  },
  {
    label: "App Metrica",
    icon: "app-metrica.png",
    value: "app-metrica",
  },
  {
    label: "Trackier",
    icon: "trackier.png",
    value: "trackier",
  },
  {
    label: "Tenjin",
    icon: "tenjin.png",
    value: "tenjin",
  },
];
